/* ──────────────────────────────────────────────────────────────
 * GeometryHeader — Title bar for the geometry panel
 *
 * Sits above the GeometryViewer in Card 3 Bottom.
 * The view-flip control now lives inside GeometryViewer itself
 * (bottom-right corner of the white panel), so this header only
 * renders the "3D Preview" title.
 * ────────────────────────────────────────────────────────────── */

import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { ACCENT_COLOR } from '@/constants/colors';

const GeometryHeader: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 32,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: ACCENT_COLOR,
          fontSize: '0.875rem',
          fontWeight: 700,
          lineHeight: 1.4,
        }}
      >
        3D Preview
      </Typography>
    </Box>
  );
};

export default React.memo(GeometryHeader);